"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaService = void 0;
class CaptchaService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1CaptchaRequired() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/captcha/required',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1CaptchaSettings() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/captcha/settings',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV1CaptchaSolve({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/captcha/solve',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.CaptchaService = CaptchaService;
